import { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Shirt, CheckCircle2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ResetPassword() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const token = params.get("token") || "";
  const [pin, setPin] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (pin.length < 4) return setError("Le mot de passe doit contenir au moins 4 caractères.");
    if (pin !== confirm) return setError("Les deux mots de passe ne correspondent pas.");
    setLoading(true);
    try {
      await axios.post(`${API}/auth/reset-password`, { token, new_pin: pin });
      setDone(true);
    } catch (err) {
      setError(err.response?.data?.detail || "Une erreur est survenue.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-gradient-to-br from-sky-600 to-sky-800 p-4">
      <div className="w-full max-w-sm bg-white rounded-2xl shadow-xl p-8">
        <div className="flex flex-col items-center mb-6">
          <div className="h-16 w-16 rounded-2xl bg-sky-500 text-white grid place-items-center mb-3 shadow-lg shadow-sky-500/30"><Shirt size={30} /></div>
          <h1 className="font-display text-2xl font-extrabold text-slate-900">Nouveau mot de passe</h1>
        </div>

        {!token ? (
          <p className="text-sm text-red-600 text-center">Lien invalide. Refaites une demande depuis la page de connexion.</p>
        ) : done ? (
          <div className="text-center space-y-4">
            <CheckCircle2 size={48} className="text-emerald-500 mx-auto" />
            <p className="text-slate-700">Votre mot de passe a été réinitialisé.</p>
            <Button data-testid="reset-goto-login" onClick={() => nav("/login")} className="w-full bg-sky-600 hover:bg-sky-700">Se connecter</Button>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <div>
              <Label htmlFor="new-pin">Nouveau mot de passe / PIN</Label>
              <Input id="new-pin" data-testid="reset-pin" type="password" value={pin} onChange={(e) => setPin(e.target.value)} placeholder="••••" required />
            </div>
            <div>
              <Label htmlFor="confirm-pin">Confirmer</Label>
              <Input id="confirm-pin" data-testid="reset-confirm" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} placeholder="••••" required />
            </div>
            {error && <p data-testid="reset-error" className="text-sm text-red-600">{error}</p>}
            <Button type="submit" data-testid="reset-submit" disabled={loading} className="w-full bg-sky-600 hover:bg-sky-700">
              {loading ? "Enregistrement..." : "Réinitialiser"}
            </Button>
          </form>
        )}
      </div>
    </div>
  );
}
